import { render, staticRenderFns } from "./headnav.vue?vue&type=template&id=4eb344a4&scoped=true"
import script from "./headnav.vue?vue&type=script&lang=js"
export * from "./headnav.vue?vue&type=script&lang=js"
import style0 from "./headnav.vue?vue&type=style&index=0&id=4eb344a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb344a4",
  null
  
)

export default component.exports